import React from 'react';
import PropTypes from 'prop-types';

class LoadingSpinner extends React.PureComponent
{
    static displayName = 'LoadingSpinner';

    render()
    {
        if (!this.props.loading)
        {
            return null;
        }

        return (
            <span className="material-icons">refresh</span>
        );
    }
}

LoadingSpinner.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    size: PropTypes.any,
};

LoadingSpinner.defaultProps = {
    size: '1x',
};

export default LoadingSpinner;
